

















import { Component, Vue } from 'vue-property-decorator';
import { BitFlyerModule } from '@/store/modules/bitflyer';
import MarketDataCard from './MarketDataCard.vue';

@Component({
  name: 'BitFlyerDiv',
  components: {
    MarketDataCard,
  },
  filters: {
    zeroPadding(value: number) {
      const plus = value > 0 ? '+' : '';
      return plus + value.toFixed(2) + '%';
    },
  },
})
export default class BitFlyerDiv extends Vue {
  get loaded() {
    return BitFlyerModule.ltp > 0 && BitFlyerModule.spotLtp > 0;
  }
  get ltp() {
    return BitFlyerModule.ltp;
  }
  get spotLtp() {
    return BitFlyerModule.spotLtp;
  }
  get divParcent() {
    return (
      Math.round((BitFlyerModule.ltp / BitFlyerModule.spotLtp - 1) * 10000) /
      100
    );
  }
  get divergenceClass() {
    if (this.divParcent >= 5 || this.divParcent <= -5) {
      return 'red--text';
    } else if (this.divParcent >= 4.8 || this.divParcent <= -4.8) {
      return 'orange--text';
    } else if (this.divParcent >= 0.8 || this.divParcent <= -0.8) {
      return 'yellow--text';
    } else {
      return '';
    }
  }
}
